'use client';

import { getClientApplicationConfig } from '@hc-frontend/core-context';
import Close from '@hc-frontend/core-icons/kit/close';
import Info from '@hc-frontend/core-icons/kit/info';
import type { ButtonClickEvent } from '@hc-frontend/core-ui';
import { useEventBus, useTrackingContexts } from '@hc-frontend/core-ui';
import React, { useState } from 'react';

const cookieName = 'healthcareCookiesConsent';

export function CookiesConsent() {
  const [open, setOpen] = useState(true);
  const eventBus = useEventBus();
  const contexts = useTrackingContexts();

  if (document.cookie.split('; ').find((row) => row.startsWith(cookieName))) {
    return null;
  }

  const consent = (event: React.MouseEvent<HTMLButtonElement>) => {
    eventBus.publish<ButtonClickEvent>({
      id: 'cookies-consent-acknowledgment',
      topic: 'core.ui.button.click',
      source: event.currentTarget,
      contexts,
    });

    document.cookie = `${cookieName}=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; Secure; domain=.healthcare.com; path=/`;
    setOpen(false);
  };

  if (!open) {
    return null;
  }

  const config = getClientApplicationConfig();
  const appEnv = config.core.appEnvironment;
  const subdomain = `${appEnv === 'prd' ? 'www' : `${appEnv}`}`;

  return (
    <div
      className="fixed bottom-16-16 right-16-16 z-20 rounded bg-primary-900 text-tertiary-50"
      style={{ maxWidth: 'calc(min(30rem, 92%))' }}
    >
      <div className="flex items-center justify-center px-16-24 py-16-16">
        <Info className="mr-16-24 size-48-48 text-tertiary-50" />
        <div>
          We use cookies to improve your experience on our site. By using our
          site you consent cookies.{' '}
          <a
            href={`https://${subdomain}.healthcare.com/privacy-policy#additional-information-about-our-data-collection-and-sharing-practices`}
            target="_blank"
            className="font-bold text-tertiary-50"
            rel="noopener noreferrer"
          >
            Learn more
          </a>
        </div>
        <button
          className="ml-4-16 cursor-pointer"
          id="cookies-consent-acknowledgment"
          onClick={consent}
          type="button"
          aria-label="Close cookies consent"
        >
          <Close className="size-24-24 text-tertiary-50" />
        </button>
      </div>
    </div>
  );
}
